import { render, staticRenderFns } from "./CartItemHistory.vue?vue&type=template&id=16dd005a&scoped=true&"
import script from "./CartItemHistory.vue?vue&type=script&lang=js&"
export * from "./CartItemHistory.vue?vue&type=script&lang=js&"
import style0 from "./CartItemHistory.vue?vue&type=style&index=0&id=16dd005a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd005a",
  null
  
)

component.options.__file = "CartItemHistory.vue"
export default component.exports